import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { CustomHttpResponse } from '../../classes/http';
import { Companies, CompanyCodesNames, CompanyNames, CompanyOwnershipInterface, StreetType } from './companies';

@Injectable()
export class CompaniesService {
  constructor(private http: HttpClient) {}

  getCompanies(params): Observable<CustomHttpResponse<Companies>> {
    return this.http.get<CustomHttpResponse<Companies>>(`/admin/campaigns/`, {
      params: params || {},
    });
  }

  getCompaniesFilter(params?): Observable<CustomHttpResponse<CompanyNames[]>> {
    return this.http.get<CustomHttpResponse<CompanyNames[]>>(`/admin/campaigns/names/`, {
      params: params,
    });
  }

  getCodesFilter(): Observable<CustomHttpResponse<CompanyCodesNames[]>> {
    return this.http.get<CustomHttpResponse<CompanyCodesNames[]>>(`/admin/campaigns/partner_codes/`);
  }

  getCompany(id): Observable<CustomHttpResponse<Companies>> {
    return this.http.get<CustomHttpResponse<Companies>>(`/admin/campaigns/${id}/all_versions/`);
  }

  getOwnershipTypes(): Observable<CustomHttpResponse<CompanyOwnershipInterface[]>> {
    return this.http.get<CustomHttpResponse<CompanyOwnershipInterface[]>>(`/admin/ownership_types/`);
  }

  getStreetTypes(): Observable<CustomHttpResponse<StreetType[]>> {
    return this.http.get<CustomHttpResponse<StreetType[]>>(`/admin/street_types/`);
  }

  createCompany(data): Observable<any> {
    return this.http.post(`/async/campaign/create`, data);
  }

  getCreateCompanyUnion(): Observable<any[]> {
    const ownership = this.getOwnershipTypes();
    const streetTypes = this.getStreetTypes();

    return forkJoin([ownership, streetTypes]);
  }

  getEditCompanyUnion(companyId): Observable<any> {
    const ownership = this.getOwnershipTypes();
    const streetTypes = this.getStreetTypes();
    const companyVersion = this.getCompany(companyId);

    return forkJoin([ownership, streetTypes, companyVersion]);
  }
}
